import { helper } from '@ember/component/helper';

/**
 * Verifica se il nome file è un PDF
 */
var isPdf = helper(([name]) => {
  if (typeof name !== 'string') return false;
  const lowerName = name.toLowerCase();
  return lowerName === 'pdf' || lowerName.endsWith('.pdf');
});

export { isPdf as default };
//# sourceMappingURL=is-pdf.js.map
